import { MessageTemplateSection } from "@/components/MessageTemplateSection";
import type { MessageTemplateSectionProps } from "@/components/MessageTemplateSection";
import type { UseMessageTemplatesResult } from "@/hooks/useMessageTemplates";

/**
 * 메시지 영역의 템플릿 컬럼 — `<div className="pt-0 mt-4">` 래퍼 + MessageTemplateSection.
 * xl / lg / mobile 세 variant에서 바이트 동일하게 중복돼 있던 MTS 래퍼를 단일화한 presentational 컴포넌트(P09a: xl+mobile, P09b-1: lg).
 * (lg message-tab의 4버튼 헤더 + cross-tab 메모버튼은 별도 — P09b-2 소유. 여긴 MTS 래퍼만 담당.)
 *
 * MTS의 7개 template prop(templates/activeTemplateId/onSelectTemplate/isAtMaxLimit/
 * isAtMinLimit/onCreateTemplate/onDeleteActive)은 `messageTemplates` 훅 반환을 그대로 받아
 * 내부에서 매핑한다(호출부 prop 중복 제거). 나머지 prop은 그대로 forward.
 * MessageTemplateSection이 이미 memo()라 추가 memo는 불필요(여긴 순수 구조 래퍼).
 */
export type MessageTemplateColumnProps = Omit<
  MessageTemplateSectionProps,
  | "templates"
  | "activeTemplateId"
  | "onSelectTemplate"
  | "isAtMaxLimit"
  | "isAtMinLimit"
  | "onCreateTemplate"
  | "onDeleteActive"
> & {
  // 7개 grouped prop이 읽는 필드만 선언(전체 hook API 결합 회피). Home은 hook 반환을 그대로 넘김.
  messageTemplates: Pick<
    UseMessageTemplatesResult,
    | "templates"
    | "activeTemplate"
    | "setActiveTemplateId"
    | "isAtMaxLimit"
    | "isAtMinLimit"
    | "createTemplate"
    | "deleteActiveTemplate"
  >;
};

export function MessageTemplateColumn({
  messageTemplates,
  ...rest
}: MessageTemplateColumnProps) {
  return (
    <div className="pt-0 mt-4">
      <MessageTemplateSection
        {...rest}
        templates={messageTemplates.templates}
        activeTemplateId={messageTemplates.activeTemplate?.id ?? null}
        onSelectTemplate={messageTemplates.setActiveTemplateId}
        isAtMaxLimit={messageTemplates.isAtMaxLimit}
        isAtMinLimit={messageTemplates.isAtMinLimit}
        onCreateTemplate={messageTemplates.createTemplate}
        onDeleteActive={messageTemplates.deleteActiveTemplate}
      />
    </div>
  );
}
